var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#DCEAFB",
    stroke: "#B6D4F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9933 23.6667H24C26.0133 23.6667 27.6667 22.02 27.6667 20C27.6667 17.9867 26.02 16.3333 24 16.3333H22.9933",
    stroke: "#1373E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.3333H18C15.98 16.3333 14.3333 17.98 14.3333 20C14.3333 22.0133 15.98 23.6667 18 23.6667H19",
    stroke: "#1373E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 20H23.6667",
    stroke: "#1373E7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkContent);
export default __webpack_public_path__ + "static/media/LinkContent.e328217b1dad5534af65f3fbe1b736a1.svg";
export { ForwardRef as ReactComponent };